export enum Currencies {
  PHP = "PHP",
  USD = "USD",
}
